import { render, staticRenderFns } from "./FixedMenuDesktop.vue?vue&type=template&id=1c5c3cbd&scoped=true"
import script from "./FixedMenuDesktop.vue?vue&type=script&lang=js"
export * from "./FixedMenuDesktop.vue?vue&type=script&lang=js"
import style0 from "./FixedMenuDesktop.vue?vue&type=style&index=0&id=1c5c3cbd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5c3cbd",
  null
  
)

export default component.exports